<template>
  <div>
    <CRow class="py-5 mt-4">
      <CCol>
        <MenssageAlert :messages="messages" />
      </CCol>
      <CCol xs="12" sm="12">
        <div>
          <h2 class="titlePage font-weight-bold text-capitalize mb-4">
            {{ $t('planSubscription.overview.header') }}
          </h2>
        </div>
      </CCol>

      <CCol sm="12" v-if="loading">
        <div class="text-center py-5">
          <LoadingSpinner />
        </div>
      </CCol>
      <CCol xs="12" sm="12" class="" v-if="!loading">
        <OverViewCounts :counts="counts" :isFree="isFree" :isCorporate="isCorporate" />
        <OverViewYourPlan
          :currentPlan="plansAndSubscriptions"
          :addons="addons"
          :isSubscribe="isSubscribe"
          :isFree="isFree"
          :isCorporate="isCorporate"
          @error="errorHandler"
          @cancelAddonSuccess="cancelAddonSuccess"
          @cancelAddonError="cancelAddonError"
        />
        <OverViewNextPayment v-if="isSubscribe && !isFree" :paymentThisMonth="paymentThisMonth" />
        <OverViewPayment v-if="isSubscribe && !isFree" :paymentMethod="paymentMethod" @error-payment="paymentError" @update-payment="getData()" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import OverViewCounts from '../components/OverViewCounts.vue'
import OverViewYourPlan from '../components/OverViewYourPlan.vue'
import OverViewPayment from '../components/OverViewPayment.vue'
import OverViewNextPayment from '../components/OverViewNextPayment.vue'
import { mapState } from 'vuex'
import MenssageAlert from '@/components/MenssageAlert.vue'
import services from '@/services.js'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

import { HEADER_TYPES, PLAN_FEATURES, PLAN_TYPES } from '../constants.js'

// MOCK DATA (deixei para questão de testes)
var data = {
  contacts: {
    limit: 5000,
    used: 2500,
    percent: 50,
  },
  organizationPlan: {
    id: '1349a0c7-f7cd-4648-9602-76e922088ebc',
    organizationId: '57186add-e4c1-4aab-840b-003e2bca453e',
    balanceRenewalPeriod: 1,
    organizationPlanStatus: 1,
    plan: {
      id: '425acad4-f62e-4a0e-b44e-5ccf134a6a46',
      planType: 4,
      name: 'Corporate',
    },
  },
  channels: {
    email: {
      currentBalances: [
        {
          id: '53cbdec9-1a89-4a56-851d-26a7ba8cf7e4',
          balance: 100,
        },
      ],
      recurrentAddOns: [
        {
          balance: 5,
          balanceRenewalPeriod: 1,
          id: 'b48734d7-d501-4efb-b221-1b38c0ffcdeb',
        },
      ],
    },
    sms: {
      currentBalances: [
        {
          countryId: 'RoW',
          id: 'b48734d7-d501-4efb-b221-1b38c0ffcdeb',
          balance: 5,
        },
      ],
      recurrentAddOns: [
        {
          balance: 5,
          countryId: 'RoW',
          balanceRenewalPeriod: 1,
          id: 'b48734d7-d501-4efb-b221-1b38c0ffcdeb',
        },
      ],
    },
  },
  paymentMethod: {
    card: {
      id: 'pm_1N5m5KE16FYrcGYs75ZHujHx',
      last4: '0047',
      expYear: 2027,
      expMonth: 10,
      brand: 'unionpay',
    },
  },
}

export default {
  name: 'overview',
  components: {
    OverViewCounts,
    OverViewYourPlan,
    OverViewPayment,
    OverViewNextPayment,
    MenssageAlert,
    LoadingSpinner,
  },
  data() {
    return {
      messages: [],
      loading: false,
      counts: [],
      addons: {},
      isSubscribe: false,
      isFree: false,
      isCorporate: false,
      paymentMethod: {},
      paymentThisMonth: {},
      plansAndSubscriptions: {
        currentPlan: {
          planName: 'name',
          subscriberDate: 'April 2020',
          planId: '1234-12314-1234-12444',
          features: [
            {
              id: '1',
              featureName: 'Platform Users up to 3 users',
            },
            {
              id: '2',
              featureName: 'Sub accounts up to 10 accounts',
            },
            {
              id: '3',
              featureName: '2000 e-mails/month',
            },
            {
              id: '4',
              featureName: '10 campaign templates',
            },
            {
              id: '5',
              featureName: '5 automation flows',
            },
            {
              id: '6',
              featureName: 'HTML Template Import',
            },
            {
              id: '7',
              featureName: 'E-mail support',
            },
          ],
          nextInvoice: 'Aug 7, 2022',
          amount: 31.7,
        },
        amount: 3000,
        subscriberDate: 'date',
      },
      // paymentMethods: {
      //   setupCliente: '1234-1234-1234-1234',
      //   methods: [
      //     {
      //       id: 'pm_1LXQAVE16FYrcGYsmXQMcasD',
      //       last4: 4242,
      //       expYear: 2025,
      //       expMonth: 12,
      //       brand: 'Visa',
      //     },
      //   ],
      // },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cancelAddonSuccess(obj) {
      this.scrollTop()
      this.getData()
      this.messages.push(obj)
    },
    cancelAddonError(obj) {
      this.scrollTop()
      this.messages.push(obj)
    },
    getData() {
      let organizationId = this.$route.params.organizationId
      this.messages = []
      this.loading = true
      services
        .getOverview(organizationId)
        .then((res) => {
          let response = res.data.data
          this.processData(response)
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || '',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    processData(data) {
      this.checkPlanType(data)
      this.processHeader(data)
      this.processPlan(data)
      this.processAddons(data)
      this.processPaymentMethod(data)
      this.processPaymentThisMonth(data)
    },

    checkPlanType(data) {
      // this.isSubscribe = false
      // this.isFree = true
      this.isSubscribe = data.organizationPlan.plan.planType == PLAN_TYPES.STANDARD
      this.isFree = data.organizationPlan.plan.planType == PLAN_TYPES.FREE
      this.isCorporate = data.organizationPlan.plan.planType == PLAN_TYPES.CORPORATE
    },

    // ? Processamento do header
    processHeader(data) {
      let items = []
      items.push(this.processContacts(data))
      items.push(this.processChannel(data, HEADER_TYPES.EMAIL))
      items.push(this.processChannel(data, HEADER_TYPES.SMS))
      this.counts = items
    },

    processContacts(data) {
      let contacts = data.contracts
      return {
        type: HEADER_TYPES.CONTACTS,
        used: contacts.used,
        limit: contacts.limit,
        percent: contacts.percent,
      }
    },

    processChannel(data, type) {
      let totalCurrent = data.monthlyAmount ? data.monthlyAmount[type] : 0

      return {
        type: type,
        total: totalCurrent,
        period: 1,
      }
    },

    // ? Plan
    processPlan(data) {
      let organizationPlan = data.organizationPlan
      this.plansAndSubscriptions = organizationPlan
      const PLAN_KEYS = {
        free: 'free',
        starter: 'starter',
        professional: 'professional',
        corporate: 'corporate',
        payasyougo: 'payAsYouGo',
      }

      const planName = data.organizationPlan.plan.name.toLowerCase()
      const planKey = PLAN_KEYS[planName]

      this.plansAndSubscriptions.features = PLAN_FEATURES[planKey].available
      this.plansAndSubscriptions.paymentPeriod = data.paymentPeriod
      this.plansAndSubscriptions.planTier = data.planTier

      if (this.isSubscribe || this.isFree) {
        this.plansAndSubscriptions.nextInvoice = data.paymentThisMonth.nextPayment
      }

      if (this.isSubscribe) {
        let planInfoPrice = data.paymentThisMonth.items.find((elm) => elm.description.toUpperCase() == organizationPlan.plan.name.toUpperCase())
        this.plansAndSubscriptions.amount = planInfoPrice.amount
      }
      // // let payment = data.payment
      // this.plansAndSubscriptions.currentPlan.planName = organizationPlan.plan.name
      // // this.plansAndSubscriptions.currentPlan.nextInvoice = dateFormatStringMed(payment.nextPayment)
      // this.plansAndSubscriptions.currentPlan.nextInvoice = dateFormatStringMed(organizationPlan.beginDateTime)
    },

    processAddons(data) {
      this.addons = data.channels
    },

    processPaymentMethod(data) {
      this.paymentMethod = data.paymentMethod?.card
    },

    processPaymentThisMonth(data) {
      this.paymentThisMonth = data.paymentThisMonth
      this.paymentThisMonth.planName = data.organizationPlan.plan.name
    },

    paymentError(error) {
      this.messages = [error]
    },

    errorHandler(data) {
      this.messages = []
      this.messages.push(data)
      this.scrollTop()
    },

    scrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
  },
  computed: {
    ...mapState(['auth']),
  },
}
</script>

<style lang="scss" scope>
.countCard {
  height: 165px;

  .progress,
  .progress-bar {
    border-radius: 70px;
    height: 12px;
  }
}
</style>
